import React, { useState } from 'react';
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import Icons from '@/const/icons';
import { Icon } from '../icon';
import { ComboBoxOption } from '@/interfaces';
import { Typography } from '../typography';
import clsx from 'clsx';
import { Button } from '@/components/ui/button';

interface Props {
	buttonContent: string | JSX.Element;
	options: ComboBoxOption[];
	side?: 'right' | 'top' | 'bottom' | 'left' | undefined;
	sideOffset?: number | undefined;
	align?: 'center' | 'end' | 'start' | undefined;
	alignOffset?: number;
	onSelect: (values: string[]) => void;
}

export const DropdownCheckbox: React.FC<Props> = ({
	buttonContent,
	sideOffset,
	options,
	side,
	align,
	alignOffset,
	onSelect,
}) => {
	const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
	const handleToggleFilters = (value: string) => {
		const filters = selectedFilters.includes(value)
			? selectedFilters.filter((filter) => filter !== value)
			: [...selectedFilters, value];
		setSelectedFilters(filters);
		onSelect(filters);
	};

	const clearAll = () => {
		setSelectedFilters([]);
		onSelect([]);
	};
	return (
		<DropdownMenu>
			<DropdownMenuTrigger className="!outline-none relative">
				<>
					{buttonContent}
					<div
						className={clsx(
							'bg-[#2084E7] rounded-full w-[10px] h-[10px] absolute -right-2 -top-[0.1rem] border border-white',
							{
								hidden: selectedFilters.length === 0,
							}
						)}
					/>
				</>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				side={side}
				sideOffset={sideOffset}
				align={align}
				alignOffset={alignOffset}
				className="w-56 rounded-lg overflow-y-auto max-h-96 !outline-none scroll-custom"
			>
				<Button
					variant={'ghost'}
					className="font-normal flex items-center gap-2 px-2 h-12"
					onClick={clearAll}
				>
					<Icon src={Icons.broom} className="!w-6 !h-6" />
					Clear All
				</Button>
				{options.map((option, index) => {
					return (
						<DropdownMenuCheckboxItem
							key={index}
							checked={selectedFilters.includes(option.value)}
							onClick={(e) => {
								e.preventDefault();
								handleToggleFilters(option.value);
							}}
							className=" flex items-center"
						>
							<Typography type="regular-14" className="line-clamp-1">
								{option.label}
							</Typography>
						</DropdownMenuCheckboxItem>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
